import { Component } from '@angular/core';
import { IntroTwoComponent } from './intro-two.component';

@Component({
  selector: 'eid-intro-two-desktop',
  templateUrl: './intro-two.desktop.component.html',
  styleUrls: ['./intro-two.desktop.component.scss']
})
export class IntroTwoDesktopComponent extends IntroTwoComponent {}
